import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";

import ABNAPPFeatures from "./ABNAPPFeatures";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import APPBenefit from "../APPBenefits/APPBenefit";

// Main component for ABN APP
export default function ABNAPP() {
  // Overview data sections
  const data1 = [
    "EdgeAI Stack: The Edge AI Stack, also known as the Vertical Usecase Stack or Point Solution Stack, delivers AI capabilities closer to the data source. It empowers agribusinesses and partners to derive actionable insights with minimal latency, enabling faster and smarter decision-making.",

    "Supply Chain Orchestration: Optimizes coordination and efficiency across the entire supply chain ecosystem.",
    "Marketplace: Includes OnMarketplace, Social Marketplace, Social IAA Marketplace, and Agrocare Marketplace, catering to diverse agricultural needs.",
    "Contract Services: Offers contract manufacturing and contract farming to streamline production and agricultural operations.",

  ];

  const data2 = [

    "Core Edge Stack: Core Edge Stack serves as the central data processing and orchestration layer that integrates edge devices, solution services, and portals across the GBR ecosystem. Acting as a powerful intermediary between the cloud and local edge nodes",

    "Network: Provides access to networks like CBN and DTN, enhancing industry connectivity and collaboration.",
    "pSolution: Provides track & trace and end-to-end traceability for seamless monitoring and management.",

  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner className="sdh-bg" bannerTitle={["ABN APP"]} />

      {/* Solution Overview */}
      <SolutionEcosystem title="Overview" type="ABN" />

      {/* Feature Overview */}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/* Additional Features & Benefits */}
      <ABNAPPFeatures />
      <APPBenefit />
    </>
  );
}
